// init_timeline.js

export function initTimelinePlugin() {
    // Check rapido per la classe hook
    if (document.querySelector('.js-luxury-timeline')) {
        // Import dinamico
        import('./timeline.js')
            .then(module => module.default())
            .catch(err => console.error('Error loading Luxury Timeline:', err));
    }
}
